import React from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { CountDown } from 'src/components/DateAndTime/CountDown';
dayjs.extend(duration);

export const AuctionEndCountdown = ({ endTime }) => {

  return (
    <CountDown endTime={endTime} preText="Closing in&nbsp;" />
  );
};
